// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"d8e9a73c","34":"b1860d34","125":"a0d7150e","335":"96bb9ed5","339":"6d56bc36","608":"cf6f77d4","769":"971bcb76","883":"8eba3d4c"}[chunkId] + ".chunk.js";
};